import { Helmet } from 'react-helmet-async';
import '../assets/styles/Contact.css'

const Contact = () => {
  return (
    <><Helmet>
      {/* <!-- Primary Meta Tags for SEO --> */}
      <title> Contact – BuddyTech Solutions </title>
      <meta name="description" content="Get in touch with BuddyTech Solutions for enquiries on web, design, MIS, or construction consulting." />
      <meta name="keywords" content="contact BuddyTech, support, enquiries" />

      {/* <!-- Open Graph / Facebook Meta Tags --> */}
      <meta property="og:title" content="Contact – BuddyTech Solutions" />
      <meta property="og:description" content="Get in touch with BuddyTech Solutions for enquiries on web, design, MIS, or construction consulting." />
      <meta property="og:keywords" content="contact BuddyTech, support, enquiries" />
      <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      <meta property="og:url" content="https://buddytechsolutions.in/contact" />
      <meta property="og:type" content="website" />

      {/* <!-- Optional: Facebook App ID --> */}
      {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

      {/* <!-- Twitter Meta Tags --> */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Contact – BuddyTech Solutions" />
      <meta name="twitter:description" content="Get in touch with BuddyTech Solutions for enquiries on web, design, MIS, or construction consulting." />
      <meta name="twitter:keywords" content="contact BuddyTech, support, enquiries" />
      <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
    </Helmet>
      <div className="contact-wrapper">
        <header className="contact-hero">
          <h1>Contact Us</h1>
          <p>We’d love to hear from you! Reach out to us through any of the methods below.</p>
        </header>

        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:developerjayaprakash91@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919842084312" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919842084312">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default Contact;
